import React, { useState, SFC } from "react";
import { StyledBurger, Ul, BurgerStyleSheet } from "./Burger.style";

type Props = {
  open: boolean;
  onClick: () => any;
};

const Burger: React.FC<Props> = (props) => {

  return (
    <>
      <StyledBurger open={props.open} onClick={props.onClick}>
        <span style={BurgerStyleSheet.burgerSpan} />
        <span style={BurgerStyleSheet.burgerSpan} />
        <span style={BurgerStyleSheet.burgerSpan} />
      </StyledBurger>

      <Ul open={props.open}>{props.children}</Ul>
    </>
  );
};

export default Burger;
